export default __webpack_public_path__ + "f218e08f9a88e22fd14c301d6969b289.png";